import { useState, useEffect } from "react";

const FilteredImage = () => {
  const [currentFilterIndex, setCurrentFilterIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  const filters = [
    { name: "Normal", filter: "none" },
    { name: "Grayscale", filter: "grayscale(100%)" },
    { name: "Sepia", filter: "sepia(100%)" },
    { name: "Blur", filter: "blur(3px)" },
    { name: "Brightness", filter: "brightness(150%)" },
    { name: "Contrast", filter: "contrast(200%)" },
    { name: "Hue Rotate", filter: "hue-rotate(90deg)" },
    { name: "Invert", filter: "invert(100%)" },
    { name: "Saturate", filter: "saturate(200%)" },
    { name: "Opacity", filter: "opacity(70%)" },
    { name: "Drop Shadow", filter: "drop-shadow(10px 10px 20px rgba(0,0,0,0.5))" },
    { name: "Multiple", filter: "grayscale(50%) sepia(50%) brightness(120%)" },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setIsTransitioning(true);

      // Wait for transition to complete before changing filter
      setTimeout(() => {
        setCurrentFilterIndex(prevIndex => (prevIndex + 1) % filters.length);
        setIsTransitioning(false);
      }, 500);
    }, 4000);

    return () => clearInterval(interval);
  }, [filters.length]);

  return (
    <div style={{ textAlign: "center" }}>
      <div
        style={{
          position: "relative",
          display: "inline-block",
        }}
      >
        <h3
          style={{
            position: "absolute",
            top: "10px",
            left: "50%",
            transform: "translateX(-50%)",
            color: "white",
            margin: "0",
            textShadow: "2px 2px 4px rgba(0,0,0,0.8)",
            whiteSpace: "nowrap",
            zIndex: 10,
          }}
        >
          {filters[currentFilterIndex].name}
        </h3>

        <img
          src="/assets/images/demos/mountains.jpg"
          alt="Mountains with CSS filters"
          style={{
            maxWidth: "100%",
            height: "auto",
            filter: filters[currentFilterIndex].filter,
            opacity: isTransitioning ? 0.3 : 1,
            transition: "opacity 0.5s ease-in-out",
            boxShadow: "0 4px 8px rgba(0,0,0,0.3)",
          }}
        />
      </div>
    </div>
  );
};

export default FilteredImage;
